import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./GraduatesPage.css";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";

const GraduatesPage = () => {
	const bannerRef = useRef(null);
	const iframeRef = useRef(null);

	useEffect(() => {
		const banner = bannerRef.current;
		const iframe = iframeRef.current;
		if (!banner || !iframe) return;

		const baseSrc = iframe.getAttribute("data-src") || "";

		const startVideo = () => {
			banner.classList.add("is-playing");

			if (!baseSrc) return;

			const currentSrc = iframe.getAttribute("src") || "";
			if (!currentSrc) {
				iframe.setAttribute(
					"src",
					baseSrc +
						(baseSrc.includes("?") ? "&autoplay=1" : "?autoplay=1"),
				);
			} else if (!/autoplay=1/.test(currentSrc)) {
				iframe.setAttribute(
					"src",
					currentSrc +
						(currentSrc.includes("?")
							? "&autoplay=1"
							: "?autoplay=1"),
				);
			}
		};

		const playPill = banner.querySelector(".ie-play-pill");

		const handlePlayPillClick = (e) => {
			e.stopPropagation();
			startVideo();
		};

		const handleBannerClick = (e) => {
			if (banner.classList.contains("is-playing")) return;
			if (e.target.closest(".ie-cta")) return;
			startVideo();
		};

		if (playPill) {
			playPill.addEventListener("click", handlePlayPillClick);
		}
		banner.addEventListener("click", handleBannerClick);

		return () => {
			if (playPill) {
				playPill.removeEventListener("click", handlePlayPillClick);
			}
			banner.removeEventListener("click", handleBannerClick);
		};
	}, []);

	return (
		<div
			style={{
				margin: 0,
				padding: 0,
				background: "#ffffff",
				zoom: 0.97,
			}}
		>
			<Header />

			{/* HERO SECTION */}
			<div
				className="vt-grad-hero-wrap"
				role="region"
				aria-label="Hero: For Credential Holders"
			>
				<div className="vt-grad-hero-inner">
					<div className="vt-grad-hero-inner-max">
						<div className="vt-grad-hero-card">
							{/* BACKGROUND LAYER */}
							<div className="vt-grad-hero-bg">
								{/* <div className="vt-grad-circle-1" />
                <div className="vt-grad-circle-2" />
                <div className="vt-grad-circle-3" />
                <div className="vt-grad-circle-4" />
                <div
                  className="vt-grad-overlay"
                  data-layout="Default"
                /> */}
							</div>

							{/* FOREGROUND LAYOUT: TEXT + IMAGE */}
							<div className="vt-grad-hero-layout">
								{/* TEXT LEFT */}
								<div className="vt-grad-hero-content">
									<div className="vt-hero-pill">
										For Credential Holders
									</div>
									<div className="vt-grad-hero-title">
										Be Authentic. Get Noticed
									</div>
									<div className="vt-grad-hero-text-wrap">
										<div className="vt-grad-hero-body">
											Claim your digital certificate and
											carry your credentials <br></br>{" "}
											wherever opportunity takes you.
										</div>
										<div className="vt-grad-hero-cta-row">
											<div
												className="vt-grad-hero-cta"
												data-property-1="Default"
											>
												<Link
													rel="noopener noreferrer"
													aria-label="Claim Your Digital Certificate — opens in a new tab"
													to="/issuers"
													target="_blank"
												>
													<div className="vt-grad-hero-cta-inner">
														<div className="vt-grad-hero-cta-text">
															Claim Your Digital
															Certificate
														</div>
													</div>
												</Link>
											</div>
										</div>
									</div>
								</div>

								{/* IMAGE RIGHT */}
								<div
									className="vt-grad-hero-illustration"
									aria-hidden="false"
								>
									<img
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/graduates.svg"
										alt="Graduates"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* PAPER SECTION */}
			<div
				className="vt-paper-section"
				role="region"
				aria-label="Paper section: benefits"
			>
				<div className="vt-paper-section-inner">
					<div className="vt-paper-container">
						{/* Heading + description */}
						<div className="vt-paper-header">
							<div className="vt-paper-title-row">
								<div className="vt-paper-title">
									Paper Fades. Data Doesn't
								</div>
							</div>
							<div className="vt-paper-description">
								We know the anxiety of keeping original
								documents safe from flood, fire, or loss.
								VerifyTT gives you a permanent record within
								your control.
							</div>
						</div>

						{/* 3 equal cards */}
						<div
							className="vt-paper-cards-row"
							aria-label="Paper benefits"
						>
							{/* Card 1: Always Accessible */}
							<div className="vt-paper-card vt-paper-card--primary">
								<div className="vt-paper-card-header">
									<div className="vt-paper-icon-wrap-24">
										<div
											className="vt-paper-icon"
											aria-hidden="true"
										>
											<img
												className="vt-paper-icon-img1"
												alt=""
												aria-hidden="true"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/common_in_all.svg"
											/>
											<img
												className="vt-paper-icon-img2"
												alt=""
												aria-hidden="true"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/graduates_1_1.svg"
											/>
										</div>
									</div>
									<div className="vt-paper-card-title">
										Always Accessible
									</div>
								</div>
								<div className="vt-paper-card-text">
									On your phone, 24/7.
								</div>
							</div>

							{/* Card 2: Always Yours */}
							<div
								className="vt-paper-card vt-paper-card--primary"
								data-property-1="Default"
								aria-label="Always Yours"
							>
								<div className="vt-paper-card-header">
									<div className="vt-paper-icon-wrap-28">
										<div
											className="vt-paper-icon-28"
											aria-hidden="true"
										>
											<div className="vt-paper-icon-2-inner">
												<img
													className="vt-paper-icon-img1"
													alt=""
													aria-hidden="true"
													src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/graduates_1_2.svg"
												/>
												<img
													className="vt-paper-icon-img2"
													alt=""
													aria-hidden="true"
													src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/AlwaysYours.svg"
												/>
											</div>
										</div>
									</div>
									<div className="vt-paper-card-title">
										Always Yours
									</div>
								</div>
								<div className="vt-paper-card-text">
									You control who sees your data
								</div>
							</div>

							{/* Card 3: Always Verified */}
							<div
								className="vt-paper-card vt-paper-card--primary"
								data-property-1="Default"
								aria-label="Always Verified"
							>
								<div className="vt-paper-card-header">
									<div className="vt-paper-icon-wrap-24">
										<div
											className="vt-paper-icon"
											aria-hidden="true"
										>
											<img
												className="vt-paper-icon-img1"
												alt=""
												aria-hidden="true"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/graduates_1_3.svg"
											/>
											<img
												className="vt-paper-icon-img2"
												alt=""
												aria-hidden="true"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/AlwaysVerified.svg"
											/>
										</div>
									</div>
									<div className="vt-paper-card-title">
										Always Verified
									</div>
								</div>
								<div className="vt-paper-card-text">
									Employers trust the "Blue Tick."
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* HOW IT WORKS */}
			<div className="ghw-outer" role="region" aria-label="How it works">
				<div className="ghw-panel">
					{/* LEFT: Title + Illustration */}
					<div className="ghw-left">
						{/* Text */}
						<div className="ghw-text-block">
							<div className="ghw-title">
								3-Step illustrative flow for
								<br /> Academic certificates
							</div>
							<div className="ghw-subtitle">
								Every step is engineered to protect your
								reputation and simplify your operations
							</div>
						</div>

						{/* Illustration card */}
						<div className="ghw-illustration-card">
							<div
								className="ghw-illustration-inner"
								aria-hidden="false"
							>
								<img
									src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/graduates_sec_3_1.svg"
									alt="How it works illustration"
								/>
							</div>
						</div>
					</div>

					{/* RIGHT: Steps */}
					<div className="ghw-steps" aria-label="Steps">
						{/* Step 01 */}
						<div className="ghw-step" aria-label="Step 01: Claim">
							<div className="ghw-step-badge">
								<div className="ghw-step-number">01</div>
							</div>
							<div className="ghw-step-content">
								<div className="ghw-step-title">Claim</div>
								<div className="ghw-step-text">
									Receive an email from your institution and
									download the VerifyTT app.
								</div>
							</div>
						</div>

						{/* Arrow under 01 */}
						<div className="ghw-arrow-row" aria-hidden="true">
							<div className="ghw-arrow-col">
								<div className="ghw-arrow" />
							</div>
							<div className="ghw-arrow-fill" />
						</div>

						{/* Step 02 */}
						<div className="ghw-step" aria-label="Step 02: Store">
							<div className="ghw-step-badge">
								<div className="ghw-step-number">02</div>
							</div>
							<div className="ghw-step-content">
								<div className="ghw-step-title">Store</div>
								<div className="ghw-step-text">
									Your credential is cryptographically hashed
									and stored in your secure wallet.
								</div>
							</div>
						</div>

						{/* Arrow under 02 */}
						<div className="ghw-arrow-row" aria-hidden="true">
							<div className="ghw-arrow-col">
								<div className="ghw-arrow" />
							</div>
							<div className="ghw-arrow-fill" />
						</div>

						{/* Step 03 */}
						<div className="ghw-step" aria-label="Step 03: Share">
							<div className="ghw-step-badge">
								<div className="ghw-step-number">03</div>
							</div>
							<div className="ghw-step-content">
								<div className="ghw-step-title">Share</div>
								<div className="ghw-step-text">
									Generate a QR code to share your Verified
									Introduction with recruiters instantly.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* ISSUANCE EXPERIENCE VIDEO BANNER */}
			{/* <div className="ie-section" role="region" aria-label="Issuance experience demo">
        <div className="ie-banner" ref={bannerRef}> */}
			{/* Background gradient */}
			{/* <div className="ie-bg-wrapper">
            <div className="ie-bg-overlay" />
          </div> */}

			{/* YouTube video as background */}
			{/* <div className="ie-video-bg">
            <iframe
              ref={iframeRef}
              title="YouTube video player"
              data-src="https://www.youtube.com/embed/p6oro5MYtHc?si=gHsx-qF2K5VrvG-U&mute=1&playsinline=1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div> */}

			{/* Dark overlay above video */}
			{/* <div className="ie-video-overlay"  aria-hidden="true"/> */}

			{/* Centered content */}
			{/* <div className="ie-content">
            <div className="ie-heading-group">
              <div className="ie-eyebrow">The Issuance Experience</div>
              <div className="ie-subtitle">15-second demo</div>
            </div>

            <div className="ie-play-pill" aria-label="Play 15-second demo">
              <div className="ie-play-icon-wrapper">
                <div className="ie-play-icon-inner">
                  <img
                    src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Play.svg"
                    alt="play"
                    
                      aria-hidden="true"
                  />
                </div>
              </div>
            </div>

            <div className="ie-cta" data-property-1="Default">
              <div className="ie-cta-inner">
                <div className="ie-cta-text" aria-label=" Claim Your Digital Certificate">
                  Claim Your Digital Certificate
                </div>
              </div>
            </div>
          </div> */}

			{/* Keeps same vertical height as your original */}
			{/* <div className="ie-height-spacer" />
        </div> */}
			{/* </div> */}

			{/* FOOTER */}
			<Footer />
		</div>
	);
};

export default GraduatesPage;
